import React, { memo, Children, useState, useCallback, useEffect } from 'react'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Tooltip from '@material-ui/core/Tooltip'

import DropDownButton from './DropDownButton'
import CustomScroll from 'components/CommonUI/CustomScroll/CustomScroll'

import Check from '../svgIcons/Check'

/* 

  @params
  itemData: [{id, label. value}]
  
**/

export const DropdownMenuItem = ({
  children,
  onClick,
  itemData = {},
  selectedValueId,
}) => {
  const handleClick = () => {
    if (typeof onClick === 'function') {
      onClick(itemData)
    }
  }

  return (
    <div className="menu_item_container" onClick={handleClick}>
      {itemData?.id && itemData.id === selectedValueId && (
        <span className="dropdown_menu_item_check_icon">
          <Check />
        </span>
      )}
      <Tooltip
        title={typeof children === 'string' ? children : ''}
        enterDelay={600}
      >
        <span className="label">{children}</span>
      </Tooltip>
    </div>
  )
}

export const Line = () => <span className="dropdown-menu-line" />

export const EmptySearchItem = () => (
  <span className="menu_item_empty">Nothing was found</span>
)

const DropdownMenu = ({
  classNameContainer = '',
  selectedValue = {}, // should contain keys 'id', 'label', 'value'
  handleSelectedClick,
  emptyValue = '',
  controlComponent: ControlComponent = null,
  children,
  styleMenu = {},
  controlProps = {},
  withoutLabel = false,
  defaultValueItem = null,
  label = '',
  disabled,
  withSearch = false,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const [searchValue, setSearchValue] = useState('')

  const handleChangeSearchValue = useCallback(
    (e) => {
      if (isOpen) {
        setSearchValue(e.target.value)
      }
    },
    [isOpen]
  )

  const handleToggleClick = () => {
    setIsOpen((prev) => !prev)
  }

  const handleClickAway = () => {
    setIsOpen(false)
  }

  useEffect(() => {
    if (!isOpen) {
      setSearchValue('')
    }
  }, [isOpen])

  const classNameIsNotSelected =
    !selectedValue?.label && !withoutLabel ? 'no_selected' : ''

  const classNameDisabled = disabled ? 'disabled' : ''

  const Control = ControlComponent || DropDownButton

  const filteredChildren = children?.filter((c) =>
    String(c?.props?.itemData?.label)
      .toLowerCase()
      .includes(String(searchValue).toLowerCase())
  )

  const isSearchEmpty = !filteredChildren?.length

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div
        className={`dropdown_container ${classNameContainer} ${classNameIsNotSelected} ${classNameDisabled}`}
      >
        {!!label && <span className="form-support-label">{label}</span>}
        <Control
          active={isOpen}
          onClick={disabled ? null : handleToggleClick}
          value={
            withSearch && isOpen
              ? searchValue
              : selectedValue?.label || emptyValue
          }
          className={'dropdown_control'}
          disabled={disabled}
          withSearch={withSearch}
          onChange={handleChangeSearchValue}
          {...controlProps}
        />
        {isOpen && (
          <div
            className="dropdown_menu_container"
            style={styleMenu}
            onClick={handleClickAway}
          >
            <CustomScroll
              className="dropdown_menu_scroll_wrap"
              isHorisontal={false}
            >
              {isSearchEmpty && <EmptySearchItem />}
              {defaultValueItem && (
                <>
                  <DropdownMenuItem
                    itemData={defaultValueItem}
                    onClick={handleSelectedClick}
                    selectedValueId={selectedValue?.id}
                  >
                    {defaultValueItem.label}
                  </DropdownMenuItem>
                  <Line />
                </>
              )}
              {Children.map(filteredChildren, ({ props, type }) => {
                const { children: _children, ...rest } = props

                const _label = _children || props?.itemData?.label

                switch (type) {
                  case Line:
                    return <Line />
                  case DropdownMenuItem:
                    return (
                      <DropdownMenuItem
                        onClick={handleSelectedClick}
                        selectedValueId={selectedValue?.id}
                        {...rest}
                      >
                        {_label}
                      </DropdownMenuItem>
                    )
                  default:
                    return null
                }
              })}
            </CustomScroll>
          </div>
        )}
      </div>
    </ClickAwayListener>
  )
}

export default memo(DropdownMenu)
